import { ModuleModel } from '../../module.model.interface';

export enum OfficialActKind {
  LejartHatarido
}

export class OfficialActKindDetail implements ModuleModel {
  public discriminator = 'OfficialActKindDetail';
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const OfficialActKindMap = {
  LejartHatarido: new OfficialActKindDetail({ id: 'LejartHatarido', name: 'Lejárt határidejű adatszolgáltatás' }),
};

export const OfficialActKindList: OfficialActKindDetail[] = [
  OfficialActKindMap.LejartHatarido,
];


export enum OfficialActType {
  HivatalosLevel,
  FelszolitoHatarozat,
  BirsagHatarozat
}

export class OfficialActTypeDetail implements ModuleModel {
  public discriminator = 'OfficialActTypeDetail';
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const OfficialActTypeMap = {
  HivatalosLevel: new OfficialActTypeDetail({ id: 'HivatalosLevel', name: 'Hivatalos levél' }),
  FelszolitoHatarozat: new OfficialActTypeDetail({ id: 'FelszolitoHatarozat', name: 'Felszólító határozat' }),
  BirsagHatarozat: new OfficialActTypeDetail({ id: 'BirsagHatarozat', name: 'Bírság határozat' }),
};

export const OfficialActTypeList: OfficialActTypeDetail[] = [
  OfficialActTypeMap.HivatalosLevel,
  OfficialActTypeMap.FelszolitoHatarozat,
  OfficialActTypeMap.BirsagHatarozat,
];

export enum OfficialActState {
  Letrehozva,
  IktatonakAtadva,
  IktatobanExpedialva,
  IktatobanSztornozva,
  CimzettAtvette,
  CimzettAtveteltMegtagadta,
  CimzettKezbesitesiVelelemBeallt,
  HivataliDontesreVar,
  BirosagiDontesreVar,
  JogeroreEmelkedve,
  Visszavonva
}

export class OfficialActStateDetail implements ModuleModel {
  public discriminator = 'OfficialActStateDetail';
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const OfficialActStateMap = {
  Letrehozva: new OfficialActStateDetail({ id: 'Letrehozva', name: 'Létrehozva' }),
  IktatonakAtadva: new OfficialActStateDetail({ id: 'IktatonakAtadva', name: 'Iktatónak átadva' }),
  IktatobanExpedialva: new OfficialActStateDetail({ id: 'IktatobanExpedialva', name: 'Iktatóban expediálva' }),
  IktatobanSztornozva: new OfficialActStateDetail({ id: 'IktatobanSztornozva', name: 'Iktatóban sztornózva' }),
  CimzettAtvette: new OfficialActStateDetail({ id: 'CimzettAtvette', name: 'Címzett átvette' }),
  CimzettAtveteltMegtagadta: new OfficialActStateDetail({ id: 'CimzettAtveteltMegtagadta', name: 'Címzett átvételt megtagadta' }),
  CimzettKezbesitesiVelelemBeallt: new OfficialActStateDetail({ id: 'CimzettKezbesitesiVelelemBeallt', name: 'Címzett kézbesítési vélelem beállt' }),
  HivataliDontesreVar: new OfficialActStateDetail({ id: 'HivataliDontesreVar', name: 'Hivatali döntésre vár' }),
  BirosagiDontesreVar: new OfficialActStateDetail({ id: 'BirosagiDontesreVar', name: 'Bírósági döntésre vár' }),
  JogeroreEmelkedve: new OfficialActStateDetail({ id: 'JogeroreEmelkedve', name: 'Jogerőre emelkedve' }),
  Visszavonva: new OfficialActStateDetail({ id: 'Visszavonva', name: 'Visszavonva' }),
};

export const OfficialActStateList: OfficialActStateDetail[] = [
  OfficialActStateMap.Letrehozva,
  OfficialActStateMap.IktatonakAtadva,
  OfficialActStateMap.IktatobanExpedialva,
  OfficialActStateMap.IktatobanSztornozva,
  OfficialActStateMap.CimzettAtvette,
  OfficialActStateMap.CimzettAtveteltMegtagadta,
  OfficialActStateMap.CimzettKezbesitesiVelelemBeallt,
  OfficialActStateMap.HivataliDontesreVar,
  OfficialActStateMap.BirosagiDontesreVar,
  OfficialActStateMap.JogeroreEmelkedve,
  OfficialActStateMap.Visszavonva,
];


export class OfficialActDescriptor implements ModuleModel {
  public discriminator = 'OfficialActDescriptor';

  public id: string;
  public organizationId: string;
  public labelId: string;
  public previousActId: string;
  public rootActId: string;
  public reference: string;
  public actKind: OfficialActKind;
  public actType: OfficialActType;
  public actState: OfficialActState;
  public createdOn: Date;
  public resolutionNumber: string;
  public filingNumber: string;
  public dueDateDays: number;
  public signedOn: Date;
  public receivedOn: Date;
  public dueDate: Date;
  public clerkId: string;
  public finalDate: Date;
  public ksznyNumber: string;
  public revocationFilingNumber: string;

  public href: string;
  public modified: Date;
  public deleted: Date;

  constructor(options?: {
    id: string;
    organizationId: string;
    labelId: string;
    previousActId: string;
    rootActId: string;
    reference: string;
    actKind: OfficialActKind;
    actType: OfficialActType;
    actState: OfficialActState;
    createdOn: Date;
    resolutionNumber: string;
    filingNumber: string;
    dueDateDays: number;
    signedOn: Date;
    receivedOn: Date;
    dueDate: Date;
    clerkId: string;
    finalDate: Date;
    ksznyNumber: string;
    revocationFilingNumber: string;
    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.organizationId = options.organizationId;
      this.labelId = options.labelId;
      this.previousActId = options.previousActId;
      this.rootActId = options.rootActId;
      this.reference = options.reference;
      this.actKind = options.actKind;
      this.actType = options.actType;
      this.actState = options.actState;
      this.createdOn = options.createdOn;
      this.resolutionNumber = options.resolutionNumber;
      this.filingNumber = options.filingNumber;
      this.dueDateDays = options.dueDateDays;
      this.signedOn = options.signedOn;
      this.receivedOn = options.receivedOn;
      this.dueDate = options.dueDate;
      this.clerkId = options.clerkId;
      this.finalDate = options.finalDate;
      this.ksznyNumber = options.ksznyNumber;
      this.revocationFilingNumber = options.revocationFilingNumber;
      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}

export enum OfficialActMachineAttributeName {
  FilingNumber,
  SignedOnDate,
  ReceivedOnDate,
  ResolutionNumber,
  FinalDate,
  KsznyNumber,
  RevocationFilingNumber
}

export class OfficialActMachineAttribute {
  public name: OfficialActMachineAttributeName;
  public value: string;
  public optional: boolean;
  public object: OfficialActDescriptor;

  constructor(options?: {
    name: OfficialActMachineAttributeName;
    value: string;
    optional: boolean;
    object: OfficialActDescriptor;
  }) {

    if (options) {
      this.name = options.name;
      this.value = options.value;
      this.optional = options.optional;
      this.object = options.object;
    }
  }
}

export enum OfficialActMachineCommand {
  IktatonakAtad,
  IktatobanExpedial,
  IktatobanSztornoz,
  CimzettAtveteltRogzit,
  CimzettAtvetelMegtagadastRogzit,
  CimzettKezbesitesiVelelemBeallastRogzit,
  HatarozatszamotRogzit,
  JogeroreEmel,
  KeresetetRogzit,
  BirosagraKuld,
  Visszavon
}

export const OfficialActMachineCommandMessage = {
  IktatonakAtad : { done: 'Az iktatónak átadás sikeresen megtörtént.', fail: 'Az iktatónak átadás nem sikerült.' },
  IktatobanExpedial : { done: 'Az iktatóban expediálás sikeresen megtörtént.', fail: 'Az iktatóban expediálás nem sikerült.' },
  IktatobanSztornoz : { done: 'Az iktatóban sztornózás sikeresen megtörtént.', fail: 'Az iktatóban sztornózás nem sikerült.' },
  CimzettAtveteltRogzit : { done: 'Címzett átvétel rögzítése sikeresen megtörtént.', fail: 'Címzett átvétel rögzítése nem sikerült.' },
  CimzettAtvetelMegtagadastRogzit : { done: 'Címzett átvétel megtagadás rögzítése sikeresen megtörtént.', fail: 'Címzett átvétel megtagadás rögzítése nem sikerült.' },
  CimzettKezbesitesiVelelemBeallastRogzit : { done: 'Címzett kézbesítési vélelem rögzítése sikeresen megtörtént.', fail: 'Címzett kézbesítési vélelem rögzítése nem sikerült.' },
  HatarozatszamotRogzit : { done: 'A határozatszám rögzítése sikeresen megtörtént.', fail: 'A határozatszám rögzítése nem sikerült.' },
  JogeroreEmel : { done: 'A jogerőre emelés sikeresen megtörtént.', fail: 'A jogerőre emelés nem sikerült.' },
  KeresetetRogzit : { done: 'A kereset rögzítése sikeresen megtörtént.', fail: 'A kereset rögzítése nem sikerült.' },
  BirosagraKuld : { done: 'A bíróságra küldés sikeresen megtörtént.', fail: 'A bíróságra küldés nem sikerült.' },
  Visszavon : { done: 'A visszavonás sikeresen megtörtént.', fail: 'A visszavonás nem sikerült.' },
};

export class OfficialActMachineStateDescriptor implements ModuleModel {
  public discriminator = 'OfficialActMachineStateDescriptor';

  public command?: OfficialActMachineCommand;
  public attributes?: OfficialActMachineAttribute[];

  constructor(options?: {
    command?: OfficialActMachineCommand;
    attributes?: OfficialActMachineAttribute[];
    }) {

    if (options) {
      this.command = options.command;
      this.attributes = options.attributes;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/officialact/model/officialact.ts